module.exports = __webpack_public_path__ + "static/media/architecture-and-city.289a1683.png";